import * as React from 'react';
import { SuccessIcon, CrossIcon, FailureIcon } from '../../icons/appIcons';
require('./componentStyles/notificationBar.css')
import * as gls from '../../ap/layout/gls';

/** Utility function to create a K:V from a list of strings */
function strEnum<T extends string>(o: Array<T>): {[K in T]: K} {
  return o.reduce((res, key) => {
    res[key] = key;
    return res;
  }, Object.create(null));
}

/** Create a K:V */
export const Status = strEnum([
  'success',
  'failure'
])

/** Create a Type */
export type Status = keyof typeof Status;

interface NotificationBarProps {
  message: string,
  show: boolean,
  type: Status
}
interface NotificationBarState {
  visible : boolean
}


export class NotificationBar extends React.Component<NotificationBarProps, NotificationBarState> {

    constructor(props) {
        super(props);
        this.state = { visible: props.show };

        // This binding is necessary to make `this` work in the callback
        this.handleClick = this.handleClick.bind(this);
    }

    visible(visibility : boolean){
        this.setState({visible: visibility});
    }

    handleClick(){
        this.visible(false);
    }

    public render() {
      function AlertIcon(props) {
        const alertType = props.alertType;
        switch (alertType)
            {
            case Status.success:
              return <SuccessIcon />
            case Status.failure:
              return <FailureIcon />
            default:
              return <SuccessIcon />
            }
    }

      var message = this.props.message;
      return this.state.visible ? (
        <div className={'block-notif ' + this.props.type}>
          <span className='alert-icon'><AlertIcon alertType={this.props.type} /></span>
          <span className='notif-content'>{message}</span>
          <span className='hide-icon' onClick={this.handleClick}><CrossIcon /></span>
        </div>
      ) : null;
    }
  }

